import axios from '@/core/axios';

/* Comptes comptables généraux (cf. AccountingAccountsSettingsController côté back) :
 * comptes structurels des exports et paramètres de l'autoliquidation de TVA. */
export type AccountingAccountKey =
  | 'discount'
  | 'commercial_gesture'
  | 'customs_fees'
  | 'delivery_delay'
  | 'promo_code_credit_note'
  | 'item_not_received_lost'
  | 'situation_client_fae'
  | 'situation_client_aae'
  | 'situation_vat_fae'
  | 'situation_vat_aae';

export type ReverseChargeKey = 'rate' | 'due_account' | 'deductible_account';

export interface AccountingAccountsSettings {
  /* null lorsque la valeur n'est pas renseignée (aucun compte de secours). */
  accounts: Record<AccountingAccountKey, string | null>;
  reverse_charge: Record<ReverseChargeKey, string | number | null>;
}

export interface AccountingAccountsSettingsPayload {
  accounts: Partial<Record<AccountingAccountKey, string>>;
  reverse_charge: Partial<Record<ReverseChargeKey, string | number>>;
}

export class AccountingAccountsService {
  get(): Promise<AccountingAccountsSettings> {
    return axios.get<AccountingAccountsSettings>('/accounting/accounts-settings').then(resp => resp?.data);
  }

  update(payload: AccountingAccountsSettingsPayload): Promise<AccountingAccountsSettings> {
    return axios.put<AccountingAccountsSettings>('/accounting/accounts-settings', payload).then(resp => resp?.data);
  }
}

export const accountingAccountsService = new AccountingAccountsService();
